/*
 * @Description: 
 * @version: 
 * @Author: 小六
 * @Date: 2022-04-20 09:53:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-30 10:53:20
 */
import Vue from 'vue'
import Vuex from 'vuex'
// import { login } from '../../api/index'

Vue.use(Vuex)

function storeLocalStore(state) {
    window.localStorage.setItem("tokens", state);
}

const state = () => ({
    tokens: '',
    role: '',
    user_id: '',
    organization_id: '',
    organization_id_me: '',
    search_index: 0,
    meta_all: ''
})
const getters = {
    tokens: (state) => state.tokens,
    role: (state) => state.role,
    user_id: (state) => state.user_id,
    organization_id: (state) => state.organization_id,
    organization_id_me: (state) => state.organization_id_me,
    search_index: (state) => state.search_index,
    meta_all: (state) => state.meta_all

}

const mutations = {
    /**
 * @description 设置token
 * @param {*} state
 * @param {*} token
 */
    setToken(state, tokens) {
        state.tokens = tokens
        storeLocalStore(tokens)
    },
    setRole(state, val) {
        state.role = val
    },
    setUser_id(state, val) {
        state.user_id = val
    },
    setOrganization_id(state, val) {
        state.organization_id = val
    },
    setOrganization_id_me(state, val) {
        state.organization_id_me = val
    },
    setSearch_index(state, val) {
        state.search_index = val
    },
    setMeta_all(state, val) {
        state.meta_all = val
    },

    async resetAll({ commit, dispatch }) {
        await dispatch('setToken', '')
        localStorage.removeItem('tokens')
    },
}

const actions = {
    setToken({ commit }, val) {
        commit('setToken', val)
    },
    setRole({ commit }, val) {
        // 异步请求后端获取当前位置数据
        commit('setRole', val)
    },
    setUser_id({ commit }, val) {
        // 异步请求后端获取当前位置数据
        commit('setUser_id', val)
    },
    setOrganization_id({ commit }, val) {
        commit('setOrganization_id', val)
    },
    setOrganization_id_me({ commit }, val) {
        commit('setOrganization_id_me', val)
    },
    setSearch_index({ commit }, val) {
        commit('setSearch_index', val)
    },
    setMeta_all({ commit }, val) {
        commit('setMeta_all', val)
    },


}

export default {
    state,
    getters,
    mutations,
    actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js